import React from 'react';
import { useNavigate } from 'react-router-dom';
import SolutionsSection from '../components/SolutionsSection';
import SEO from "../components/SEO";
import { homeSchema } from "../seo/schema";

import '../styles/Hero.css';

import '../styles/IntroSection.css'

export default function LandingPage() {
  
  const navigate = useNavigate();
  
  const handleNavigate = (link) =>{
    navigate(link);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Magyne ERP | Business Management Software for Africa"
        description="Magyne is a SaaS and ERP platform for schools, healthcare organizations, local authorities, hotels, car washes and businesses across Africa."
        path="/"
        schema={homeSchema}
      />

      <main>
        <section className="hero">
          <div className="hero-image">
            <img src='images/hero.jpg' alt="Hero Image" />
          </div>

          {/* Text Overlay */}
          <div className="hero-content">
          <h1>
            Magyne ERP <br/> Business Management Software for Africa
          </h1>
          <p>
            Magyne is a modular SaaS and enterprise resource planning
            platform designed to help organizations manage their
            operations, people, finances and services from one platform.
          </p>
            <div className="hero-buttons">
              <button className="btn-primary mb-2" onClick={() => handleNavigate('/solutions')}>Explore Magyne Solutions</button>
              <button className="btn-secondary" onClick={() => handleNavigate('/contact-us')}>Contact Us</button>
            </div>
          </div>
        </section>
        
        <section className="intro-section mt-2">
          <div className="purpose">
            <h2 className='solutions-title'>Software built for real organizations</h2>
          </div>

          <p>
            Magyne provides specialized management solutions for
            schools, healthcare organizations, local authorities,
            hotels, car washes and growing businesses.
          </p>
          
          <div className="bg-shape shape1"></div>
          <div className="bg-shape shape2"></div>
        </section>

        <SolutionsSection />

        <section className="intro-section">
          <div className="who-we-serve">
            <h2>Magyne Solutions</h2>

            <div className="features-intro">
              <div className="feature-card">
                <i className="bi bi-mortarboard"></i>
                <h3>Magyne School</h3>
                <p>
                  School management software for student administration,
                  academics, attendance, examinations, billing and payments.
                </p>
                <a href="/solutions/school?productId=2cff8f59-b62c-4a63-84a9-f5fb3e5714c5">Learn about Magyne School</a>
              </div>

              <div className="feature-card">
                <i className="bi bi-mortarboard"></i>
                <h3>Magyne Campus</h3>
                <p>
                  Higher learning institutions management software for student administration,
                  academics, attendance, examinations, billing and payments.
                </p>
                <a href="/solutions/campus?productId=555ae16a-8b65-4b4f-bd00-70de6c5a24ac">Learn about Magyne Campus</a>
              </div>

              <div className="feature-card hr">
                <i className="bi bi-hospital"></i>
                <h3>Magyne Medic</h3>
                <p>
                  Healthcare management software for hospitals, clinics
                  and healthcare organizations.
                </p>
                <a href="/solutions/medic?productId=35b9d149-23b3-434a-9d0f-17d7d55c3806">Learn about Magyne Medic</a>
              </div>

              <div className="feature-card operations">
                <i className="bi bi-droplet"></i>
                <h3>Magyne Carwash</h3>
                <p>
                  Management and POS software for modern car wash businesses.
                </p>
                <a href="/solutions/carwash?productId=5a28c17b-0d18-4f94-967d-ccedacd0f39c">Learn about Magyne Carwash</a>
              </div>

              <div className="feature-card operations">
                <i className="bi bi-house"></i>
                <h3>Magyne Check-Ins</h3>
                <p>
                  Bookings and reservations system for hotels, lodges, boarding houses and guest houses.
                </p>
                <a href="/solutions/checkins?productId=eb9d53c4-472c-4c70-8e8d-f9a5f7add291">Learn about Magyne Check-Ins</a>
              </div>
            </div>

            {/* Floating Shapes */}
            <div className="floating-shape shape1"></div>
            <div className="floating-shape shape2"></div>
            <div className="floating-shape shape3"></div>
          </div>

        </section>

        <section className="intro-section">
          <div className="who-we-serve">
            <h2>Why Magyne?</h2>
            <p>Modular SaaS architecture</p>
            <p>Industry-specific solutions</p>
            <p>Centralized business management</p>
            <p>Designed for African organizations</p>
            <p>Accessible from anywhere</p>
            {/* Floating Shapes */}
            <div className="floating-shape shape1"></div>
            <div className="floating-shape shape2"></div>
            <div className="floating-shape shape3"></div>
          </div>

        </section>
      </main>
    </div>
  );
}
